import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "custom-font-text" }
const _hoisted_2 = ["data-js"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["no-html-error-text"]

import {ref, computed, onMounted, onBeforeUnmount} from 'vue';
    import {useStore} from 'vuex';
    import {TipsPart} from '@/profile-creation-wizard/components/for-creation/TipsPart';
    import '@malt/joy-entrypoint/src/js/components/Input/InputPhone.js';
    import {useTranslation, useGlobalProperties} from '@malt/vue3-use';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {eventBusProfileCreationWizard} from '@/profile-creation-wizard/common/events';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import type {InputPhoneValidation} from '@/profile-creation-wizard/common/types';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import mutations from '@/profile-creation-wizard/store/creation/mutations';

    export interface Props {
        optional?: boolean;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneSelection',
  props: {
    optional: { type: Boolean, default: true }
  },
  setup(__props: any) {

    const props = __props;

    const store = useStore();
    const {msg} = useTranslation();
    const {$pageContext} = useGlobalProperties();

    const creationForm = ref(store.getters[getters.creationForm]);

    const refLabelPhoneSelection = ref<HTMLElement>(null);
    const refInputPhoneSelection = ref<HTMLInputElement>(null);
    const refPhoneSelection = ref(null);
    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);

    const defaultCountry = computed(() => $pageContext.currentCountryCode || 'FR');
    const phoneNumber = ref<string>();
    const phoneValidation = ref<InputPhoneValidation>({validated: false, isInitialising: true});
    const displayError = computed(() => phoneNumber.value?.length && !phoneValidation.value.validated);
    const hasBeenSaved = ref(false);

    onMounted(() => {
        bottomSheetDisplayer.value = new BottomSheetDisplayer('#details-phone-bottom-sheet', refPhoneSelection.value, 'div.profile-creation-wizard');
        phoneNumber.value = creationForm.value.phoneNumber || '';
    });

    onBeforeUnmount(() => {
        refInputPhoneSelection.value.removeAttribute('value');
    });

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

    function onChange(event: Event): void {
        const target = event.target as HTMLInputElement;
        phoneNumber.value = target.value;
        if (hasBeenSaved.value) {
            store.commit(mutations.removePhone);
            hasBeenSaved.value = false;
        }
    }

    function onFocus(): void {
        eventBusProfileCreationWizard.emit('creation:focus-changed', TipsPart.phone);
    }

    function onInputPhoneValidation(customEvent: CustomEvent): void {
        const {validated, isInitialising} = customEvent.detail;
        phoneValidation.value = {validated: validated, isInitialising: isInitialising};
        if (validated && !isInitialising && phoneNumber.value.length > 0) {
            store.commit(mutations.selectPhone, phoneNumber.value);
            hasBeenSaved.value = true;
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "refPhoneSelection",
    ref: refPhoneSelection
  }, [
    _createVNode(StepItemTitle, { "is-optional": _ctx.optional }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.details.phone.title')), 1)
      ]),
      _: 1
    }, 8, ["is-optional"]),
    _createElementVNode("p", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.details.phone.notice')), 1),
    _createElementVNode("p", _hoisted_1, [
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        onClick: openBottomSheet
      }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.details.phone.help')), 1)
    ]),
    _createElementVNode("label", {
      ref_key: "refLabelPhoneSelection",
      ref: refLabelPhoneSelection,
      class: "m-input_phone phone-selection",
      "data-js": `{'c-input-phone': {defaultCountry: '${defaultCountry.value}'}}`,
      "data-phonenumber": ""
    }, [
      _createElementVNode("input", {
        ref_key: "refInputPhoneSelection",
        ref: refInputPhoneSelection,
        type: "tel",
        value: phoneNumber.value,
        onFocus: onFocus,
        onInput: onChange,
        onInputPhoneValidation: onInputPhoneValidation
      }, null, 40, _hoisted_3)
    ], 8, _hoisted_2),
    (displayError.value && phoneNumber.value.length)
      ? (_openBlock(), _createElementBlock("joy-form-error", {
          key: 0,
          "no-html-error-text": _unref(msg)('profile.creation.completion.wizard.details.phone.invalid')
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true)
  ], 512))
}
}

})